export default __webpack_public_path__ + "static/media/foto_board_1.c237cd68.png";